const focusRing = "_focusRing_giofa_3";
const focus = {
  focusRing
};
export {
  focus as f
};
